import { useState, useEffect } from 'react';
import SessionService from '../services/SessionService';

interface AuthState {
  isAuthenticated: boolean;
  isAdmin: boolean;
  userId: number | null;
  isLoading: boolean;
}

export const useAuth = () => {
  const [authState, setAuthState] = useState<AuthState>({
    isAuthenticated: false,
    isAdmin: false,
    userId: null,
    isLoading: true
  });

  useEffect(() => {
    const checkAuth = () => {
      try {
        const token = SessionService.getToken();
        const isAuthenticated = !!token;
        const userId = SessionService.getCurrentUserId();
        const isAdmin = SessionService.isCurrentUserAdmin() || SessionService.isSuperAdmin();

        setAuthState({
          isAuthenticated,
          isAdmin,
          userId,
          isLoading: false
        });
      } catch (error) {
        setAuthState({
          isAuthenticated: false,
          isAdmin: false,
          userId: null,
          isLoading: false
        });
      }
    };

    checkAuth();

    // Listener para mudanças no token (login/logout)
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'token') {
        checkAuth();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const refreshAuth = () => {
    const token = SessionService.getToken();
    const isAuthenticated = !!token;
    const userId = SessionService.getCurrentUserId();
    const isAdmin = SessionService.isCurrentUserAdmin() || SessionService.isSuperAdmin();

    setAuthState({
      isAuthenticated,
      isAdmin,
      userId,
      isLoading: false
    });
  };

  return {
    ...authState,
    refreshAuth
  };
};

export default useAuth; 